<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('upload_templates')"
          :text="$t('import-templates-info-text')"
          :btnText="$t('add_upload_template')"
          @action="goToAdd" />
        <div class="download-it">
          <h2>{{ $t('download_templates')}}</h2><br>
          <a href="/import_templates/customers.xlsx" download>{{ $t('customer_template')}}</a><br>
          <a href="/import_templates/shipments.xlsx" download>{{ $t('shipment_template')}}</a><br>
          <a href="/import_templates/items.xlsx" download>{{ $t('item_template')}}</a>
        </div>
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="goToEdit(item.id)"
            v-for="(item, index) in get_templates.items" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon
                :circle=true
                :name=getIconName(item.template_type)
                size="20" />
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">{{ $t(`${item.template_type}`) }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <a class="download-link"
      style="display: none"
      :download="`import-templates.xlsx`"
      ref="exportData"
      :href="exportDataPath" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import InfoTextBox from '@/components/global/infoTextBox';

/* eslint-disable */
export default {
  name: 'importTemplate',
  components: { InfoTextBox },
  data() {
    return {
      templateId: '',
      exportDataPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_templates',
      'get_template_by_id',
    ]),
  },
  created() {
    this.$store.dispatch('GET_TEMPLATES');
  },
  methods: {
    goToAdd() {
      this.$router.push({ path: '/settings/add-template' });
    },
    goToEdit(id) {
      this.$router.push({ path: `/settings/edit-template/${id}` });
    },
    getIconName(type) {
      return type === 'shipment_fields' ? 'truck' : 'single';
    }
  },
};
</script>
